module.exports = __webpack_public_path__ + "media/17 New Wave Hookers.8abc5d36.mp3";